module.exports = __webpack_public_path__ + "img/brasil.ef5c1122.png";